import { api } from "../../lib";

// Flat view over surgery_center_lab_report_delivery_methods for the standalone
// admin page (mirrors accountreportdelivery.service.ts for practices).
export interface SurgeryCenterReportDelivery {
  id: string;
  surgeryCenterLabId: string;
  reportDeliveryMethodId: string;
  email: string | null;
  phone: string | null;
  fax: string | null;
  address: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  surgeryCenterLab?: { name: string } | null;
  reportDeliveryMethod?: { name: string } | null;
  remoteConnectionIdentifier?: string | null;
}

export interface CreateSurgeryCenterReportDeliveryInput {
  surgeryCenterLabId: string;
  reportDeliveryMethodId: string;
  email?: string | null;
  phone?: string | null;
  fax?: string | null;
  address?: string | null;
  isActive?: boolean;
  remoteConnectionIdentifier?: string | null;
}

export interface UpdateSurgeryCenterReportDeliveryInput
  extends Partial<CreateSurgeryCenterReportDeliveryInput> {
  id: string;
}

export const surgeryCenterReportDeliveryService = {
  getAll: async () => {
    return api.get<SurgeryCenterReportDelivery[]>(
      "/admin/surgery-center-report-delivery"
    );
  },

  create: async (input: CreateSurgeryCenterReportDeliveryInput) => {
    return api.post<SurgeryCenterReportDelivery>(
      "/admin/surgery-center-report-delivery",
      input
    );
  },

  update: async (input: UpdateSurgeryCenterReportDeliveryInput) => {
    const { id, ...updates } = input;
    return api.put<SurgeryCenterReportDelivery>(
      `/admin/surgery-center-report-delivery/${id}`,
      updates
    );
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.patch<SurgeryCenterReportDelivery>(
      `/admin/surgery-center-report-delivery/${id}/toggle-active`,
      { isActive }
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/surgery-center-report-delivery/${id}`);
  },
};
